export interface CityCenter {
  city: string;
  lat: number;
  lng: number;
  neighborhoods: string[];
}

export const CITY_CENTERS: CityCenter[] = [
  {
    city: "Nairobi",
    lat: -1.286389,
    lng: 36.817223,
    neighborhoods: [
      "Westlands",
      "Kilimani",
      "Karen",
      "Lavington",
      "Runda",
      "Upper Hill",
      "Ngong Road",
      "Kasarani",
      "Embakasi",
      "South B",
    ],
  },
  {
    city: "Mombasa",
    lat: -4.043477,
    lng: 39.668206,
    neighborhoods: ["Nyali", "Bamburi", "Mtwapa", "Kizingo", "Likoni", "Shanzu"],
  },
  {
    city: "Kisumu",
    lat: -0.091702,
    lng: 34.767956,
    neighborhoods: ["Milimani", "Kondele", "Mamboleo", "Nyalenda", "Dunga"],
  },
  {
    city: "Nakuru",
    lat: -0.303099,
    lng: 36.080025,
    neighborhoods: ["Milimani", "Kiamunyi", "Section 58", "Naka", "Lanet"],
  },
  {
    city: "Eldoret",
    lat: 0.514278,
    lng: 35.269779,
    neighborhoods: ["Elgon View", "Langas", "Kimumu", "Kapsoya"],
  },
];

export function findCity(city: string | null | undefined): CityCenter | undefined {
  if (!city) return undefined;
  return CITY_CENTERS.find((entry) => entry.city.toLowerCase() === city.toLowerCase());
}

export function cityCenter(city: string | null | undefined): { lat: number; lng: number } {
  const found = findCity(city);
  return found ? { lat: found.lat, lng: found.lng } : { lat: -1.286389, lng: 36.817223 };
}

/**
 * Produce a stable, tiny offset around a city centre so multiple listings in the
 * same city don't stack exactly on top of each other on the map.
 */
export function jitterAround(lat: number, lng: number, seed: number): { lat: number; lng: number } {
  const a = Math.sin(seed * 12.9898) * 43758.5453;
  const b = Math.sin(seed * 78.233) * 12345.6789;
  const offsetLat = ((a - Math.floor(a)) - 0.5) * 0.06;
  const offsetLng = ((b - Math.floor(b)) - 0.5) * 0.06;
  return { lat: lat + offsetLat, lng: lng + offsetLng };
}

export function neighborhoodList(city: string): string[] {
  return findCity(city)?.neighborhoods ?? [];
}